/** "Maya Rodriguez" -> "MR"; "maya" -> "MA". */
export function initials(name: string): string {
  const parts = name
    .trim()
    .split(/[\s._-]+/)
    .filter(Boolean);
  const letters =
    parts.length >= 2
      ? `${parts[0]![0]}${parts[parts.length - 1]![0]}`
      : (parts[0] ?? '?').slice(0, 2);
  return letters.toUpperCase();
}
